import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesSection from "../components/home/ServicesSection";
import { Button } from "../components/ui/button";

const ServicesPage = () => {
  const handleBookCall = () => {
    alert("Booking call functionality - this would redirect to calendar booking");
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Our{" "}
              <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
                Smart
              </span>{" "}
              Services
            </h1>
            <p className="text-gray-300 text-lg md:text-xl mb-8 max-w-3xl mx-auto">
              Comprehensive marketing solutions designed specifically for real estate professionals.
            </p>
            <Button
              onClick={handleBookCall}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
            >
              Book A Consultation
            </Button>
          </div>
        </section>

        <ServicesSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;